const m = window.require("discourse/lib/ajax-error");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;